export const SUPPLIER_OPTION = 'O';
export const SUPPLIER_INCENTIVE = 'I';
export const DEALER_OPTION = 'D';

export const ITEM_FLAG = {
    NOT_SELECTED: 0x0,
    SELECTED: 0x1,
    USER_SELECTED: 0x2,
    CONFIGURATION_SELECTED: 0x4,
    INCLUDED_IN_OTHER_ITEM: 0x8,
    AVAILABLE: 0x80,
    CONFIGURATION_AVAILABLE: 0x100,
    DYNAMIC_ITEM: 0x2000,
    IGNORE_ITEM: 0x4000,
    NON_TAXABLE_FEDERAL: 0x10000,
    NON_TAXABLE_PROVINCIAL: 0x20000,
};

export const ITEM_DATA_LEVEL = {
    AVAILABLE: 0x1,
    PRICING: 0x2,
    DESCRIPTIONS: 0x4,
    DEALER_ITEMS: 0x4000,
};

export const DATA_TYPES = {
    FEATURE: {
        DATA_TYPE_ID: 1,
        TYPES: {
            MECHANICAL: 1,
            EXTERIOR: 2,
            COMMUNICATION: 3,
            INTERIOR: 4,
            SAFETY: 5,
            MODEL_TRIM: 50,
            PACKAGE: 51,
            ENGINE: 52,
            TRANSMISSION: 53,
            EXTERIOR_COLOUR: 54,
            INTERIOR_TRIM: 55,
            DEALER_INVENTORY: 2,
        },
    },
    TAX_AND_DUTY: {
        DATA_TYPE_ID: 2,
        TYPES: {
            AIR: 1,
            WEIGHT: 2,
            BATTERY: 3,
            TIRE: 4,
            ENVIRONMENTAL: 5,
            LICENCE: 6,
            RECOVERY: 7,
            LEVY: 8,
        },
    },
    FEE: {
        DATA_TYPE_ID: 3,
        TYPES: {
            FREIGHT: 1,
            PREPARATION: 2,
            MARKETING: 3,
            REGISTRATION: 4,
            ADMINISTRATION_DEALER: 8,
            DOCUMENT: 6,
            ACQUISITION: 7,
            ADMINISTRATION_CREDITOR: 5,
            RECOVERY: 9,
            RECYCLING: 10,
            SECURITY_DEPOSIT: 11,
            LEASE_BUY_BACK: 12,
            DELIVERY: 13,
            CHECKOUT_DEPOSIT: 14,
            RESERVATION_DEPOSIT: 15,
        },
    },
    PROTECTION: {
        DATA_TYPE_ID: 4,
        TYPES: {
            OEM_EXTENDED_WARRANTY: 1,
            EXTENDED_WARRANTY: 2,
            WARRANTY_PACKAGE: 11,
            PROTECTION_REPLACEMENT_WARRANTY: 21,
            PROTECTION_REPLACEMENT_INSURANCE: 22,
            PROTECTION_GAP: 41,
            ROAD_HAZARD_PACKAGE: 60,
            ROAD_HAZARD_PLAN: 61,
            APPEARANCE_PACKAGE: 100,
            APPEARANCE_INTERIOR: 101,
            APPEARANCE_PAINT: 102,
            APPEARANCE_RUST: 103,
            APPEARANCE_EXTERIOR: 104,
            THEFT_DETERRENT: 201,
            INSURANCE_LIFE: 301,
            INSURANCE_CRITICAL_ILLNESS: 302,
            INSURANCE_DISABILITY: 303,
            INSURANCE_LOSS_EMPLOYMENT: 304,
            INSURANCE_RESIDUAL: 305,
        },
        CATEGORIES: {
            WARRANTY: 1,
            INSURANCE: 2,
            APPEARANCE: 3,
            THEFT_DETERRENT: 4,
            SAFETY: 5,
            PROTECTION: 6,
        },
    },
    REBATE: {
        DATA_TYPE_ID: 5,
        TYPES: {
            DEALER_DISCOUNT: 1,
            DAA_CASH_DOWN: 4,
            EMPLOYEE: 5,
            ELECTRIC: 7,
            MSRP_PERCENTAGE: 9,
            BONUS: 10,
        },
    },
};

export const DEFAULT_MODEL_TRIM_CODE = '_MT';
export const DEFAULT_KEY_ORDER = 9999999;
export const SYSTEM_PACKAGE_CODE = '_P_';

export default {
    SUPPLIER_OPTION,
    SUPPLIER_INCENTIVE,
    DEALER_OPTION,
    ITEM_FLAG,
    ITEM_DATA_LEVEL,
    DATA_TYPES,
    DEFAULT_MODEL_TRIM_CODE,
    DEFAULT_KEY_ORDER,
    SYSTEM_PACKAGE_CODE,
};



// WEBPACK FOOTER //
// ./src/constants/dataTypes.js